// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallSummary_wrapper__1Sw59","call-summary":"CallSummary_call-summary__3G1nL"};